/**
 * Custom Filters - Sale Collection
 * Template-specific configuration for sale/discount collections
 *
 * Requires: custom-filters-core.js to be loaded first
 */

document.addEventListener('DOMContentLoaded', function() {
  // Initialize with sale-specific config - only passes hasDiscount=true
  window.CustomFilters.init({
    type: 'sale',
    collectionHandle: 'sale',
    apiParamName: 'has_discount',
    apiParamValue: 'true',
    excludedFilters: ['subcategories', 'locations', 'trends', 'motorTypes'],
    extraApiParams: {}
  });
});
